export default __webpack_public_path__ + "static/HiruniCrop-e49ebca9bb90ae0aa07749e0563ee4e1.jpg";